import { useState, useEffect } from 'react';

interface DashboardProps {
  apiEndpoint: string;
}

interface Stats {
  orders: { total: number; new_orders: number };
  products: { total: number };
  customers: { total: number };
  revenue: { total_revenue: number };
}

export default function Dashboard({ apiEndpoint }: DashboardProps) {
  const [stats, setStats] = useState<Stats | null>(null);
  const [recentOrders, setRecentOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
    fetchRecentOrders();
  }, [apiEndpoint]);

  const fetchStats = async () => {
    try {
      const response = await fetch(`${apiEndpoint}/api/store/stats?store_id=1`);
      const data = await response.json();
      setStats(data);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    }
  };

  const fetchRecentOrders = async () => {
    try {
      const response = await fetch(`${apiEndpoint}/api/orders?store_id=1&limit=5`);
      const data = await response.json();
      setRecentOrders(data.orders || []);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch orders:', error);
      setLoading(false);
    }
  };

  if (loading) return <div className="card">Loading...</div>;

  return (
    <div>
      <h1>Dashboard</h1>

      {/* Stats Grid */}
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Orders</h3>
          <div className="value">{stats?.orders?.total || 0}</div>
        </div>
        <div className="stat-card">
          <h3>Products</h3>
          <div className="value">{stats?.products?.total || 0}</div>
        </div>
        <div className="stat-card">
          <h3>Customers</h3>
          <div className="value">{stats?.customers?.total || 0}</div>
        </div>
        <div className="stat-card">
          <h3>Revenue (THB)</h3>
          <div className="value">{(stats?.revenue?.total_revenue || 0).toLocaleString()}</div>
        </div>
      </div>

      {/* Recent Orders */}
      <div className="card">
        <h2>Recent Orders</h2>
        <table>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Customer</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Payment</th>
            </tr>
          </thead>
          <tbody>
            {recentOrders.map((order) => (
              <tr key={order.order_id}>
                <td>{order.order_id}</td>
                <td>{order.name}</td>
                <td>฿{order.price?.toLocaleString()}</td>
                <td>
                  <span className={`status ${order.status}`}>{order.status}</span>
                </td>
                <td>
                  <span className={`status ${order.payment_status}`}>{order.payment_status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
